<template>
    <b-modal title="ایجاد پکیج جدید" id="modal-supportPackage-update" no-close-on-backdrop centered ok-title="ایجاد"
        cancel-title="انصراف" @cancel="closeModal" @ok.prevent="sendPackageCreateRequest">
        <b-container fluid>
            <b-form-row>
                <b-col cols="12" md="6">
                    <b-form-group label="عنوان پکیج" label-for="pkg-title">
                        <b-form-input id="pkg-title" v-model="packageDetails.title" size="sm"
                            placeholder="عنوان پکیج را وارد کنید" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="مدت کل مکالمه (دقیقه)" label-for="pkg-totalCall">
                        <b-form-input id="pkg-totalCall" v-model.number="packageDetails.totalCallMin" type="number"
                            min="0" size="sm" placeholder="مدت کل مکالمه را وارد کنید" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="مدت تماس روزانه (دقیقه)" label-for="pkg-totalCallDay">
                        <b-form-input id="pkg-totalCallDay" v-model.number="packageDetails.totalCallMinOnDay"
                            type="number" min="0" size="sm" placeholder="مدت تماس روزانه را وارد کنید" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label-for="pkg-picUrl">
                        <IconPicker @getIcon="packageDetails.picUrl=$event" v-model="packageDetails.picUrl" />

                    </b-form-group>
                </b-col>
                <b-col cols="12" md="12">
                    <b-form-group label="توضیحات" label-for="pkg-desc">
                        <b-form-textarea id="pkg-desc" v-model="packageDetails.description" rows="2" size="sm"
                            placeholder="توضیحات پکیج را وارد کنید" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="قیمت (تومان)" label-for="pkg-price">
                        <b-form-input id="pkg-price" v-model.number="packageDetails.price" type="number" min="0"
                            size="sm" placeholder="قیمت پکیج را وارد کنید" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="مدت اعتبار (روز)" label-for="pkg-expiry">
                        <b-form-input id="pkg-expiry" v-model.number="packageDetails.expiryDay" type="number" min="0"
                            size="sm" placeholder="تعداد روز اعتبار را وارد کنید" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="نمایش برای کاربران" label-for="pkg-isShow">
                        <b-form-checkbox id="pkg-isShow" v-model="packageDetails.isShow">
                            نمایش این پکیج فعال باشد
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-form-row>
        </b-container>
    </b-modal>
</template>

<script>
import {
    BModal,
    BContainer,
    BRow,
    BCol,
    BFormRow,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
} from "bootstrap-vue";
import { UpdateCounselingPackage } from "@/libs/Api/Counseling";
import IconPicker from "./IconPicker.vue";
export default {
    emits: ["refetch"],
    props: {
        packageData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            packageDetails: {
                title: "",
                totalCallMin: 0,
                totalCallMinOnDay: 0,
                picUrl: "",
                description: "",
                price: 0,
                expiryDay: 0,
                isShow: true,
            },
        };
    },
    watch: {
        packageData: {
            handler(newVal) {
                // مقداردهی مجدد فیلدها در صورت تغییر packageData
                if (newVal) {
                    this.packageDetails = { ...this.packageDetails, ...newVal }
                } else {
                    // اگر خالی بود، ریست کن
                    this.packageDetails = {
                        title: "",
                        totalCallMin: 0,
                        totalCallMinOnDay: 0,
                        picUrl: "",
                        description: "",
                        price: 0,
                        expiryDay: 0,
                        isShow: true,
                    }
                }
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        closeModal() {
            this.$bvModal.hide("modal-supportPackage-update");
        },
        async sendPackageCreateRequest() {
            try {
                this.isLoading = true;

                const _this = this;

                const updatePackage = new UpdateCounselingPackage(_this);
                updatePackage.setRequestParamDataObj(_this.packageDetails);

                await updatePackage.fetch((res) => {
                    if (res.isSuccess) {
                        _this.$emit("refetch");
                        _this.closeModal();
                    }
                });
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },
    },
    components: {
        BModal,
        BContainer,
        BRow,
        BCol,
        BFormRow,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BFormCheckbox,
        IconPicker
    },
};
</script>